import React, { useEffect, useState } from 'react';
import { zl, zaokr } from '../../functions/utilities.js';
import { translate, rodzaj_rozliczenia } from "../../functions/dictionary.js";
import { rrrr_mm_dd_to_rrrr_mm } from '../../functions/dataFormat.js';

const NotaTBody = (props) => {

    const { mieszkaniec, udzialGrupaNota, setKwota, tablicaCzynsze, stawki, stawkiJednorazoweInd, msc } = props;

    const [tablicaCzynsze_g, setTablicaCzynsze_g] = useState([]);
    const [tablicaCzynszeAkt, setTablicaCzynszeAkt] = useState([]);

    useEffect( () => setKwota( tablicaCzynszeAkt?.czynsz_na_msc ), [tablicaCzynszeAkt]);

    useEffect( () => {
        if (tablicaCzynsze && tablicaCzynsze?.length > 0) {
            const tablicaCzynsze_u = tablicaCzynsze[0]?.grupy?.find( t => t.id_user == mieszkaniec?.id_user );
            setTablicaCzynsze_g( tablicaCzynsze_u?.grupy_udzial_msc?.find( g => g?.grupa_numer === udzialGrupaNota?.grupa_numer )  );
        }
    },[tablicaCzynsze, mieszkaniec, udzialGrupaNota]);
    
    useEffect( () => {
        let len = tablicaCzynsze_g?.temp_msc?.length;
        if (len && len > 1)
            setTablicaCzynszeAkt( tablicaCzynsze_g?.temp_msc[len - 2] );
        else if (len && len === 1)
            setTablicaCzynszeAkt( tablicaCzynsze_g?.temp_msc[0] );
    },[tablicaCzynsze_g])
    
    const podstawa = (tablicaCzynszeAkt, key) => {
        const klucz = key + "_podstawa";
        return tablicaCzynszeAkt[klucz];
    }

    const puste = Array(6).fill(null).map(() => (
        <td
            style={{
                borderLeft: '1px solid black',
                borderRight: '1px solid black',
                padding: '3cm 0 0 0'
            }}
        />
    ));
    
    const tabela = (stawki) => {
        const elements = [];
        let i = 1;
        
        if (stawki) {
            const hasOwn = Object.prototype.hasOwnProperty;
            for (const key in stawki) {
                if (hasOwn.call(stawki, key) && !key.startsWith('czy_') && !key.endsWith('_rodzaj')) {
                    const rodzajKey = `${key}_rodzaj`;
                    const czyKey = `czy_${key}`;
                    const cena = stawki[key];
                    const rodzaj = stawki[rodzajKey];
                    const czyUwzgledniany = stawki[czyKey] && !isNaN(tablicaCzynszeAkt[key]);
                    
                    const podstawa_ = rodzaj_rozliczenia(rodzaj, key) == "opłata stała" ? "1" :  zaokr(podstawa(tablicaCzynszeAkt, key),2);

                    if (czyUwzgledniany && cena > 0 && tablicaCzynszeAkt[key] > 0) {
                        
                        elements.push(
                            <tr key={key}>
                                <td 
                                    style={{
                                        borderLeft: '1px solid black', 
                                        borderRight: '1px solid black',
                                        padding: '1mm 2mm',
                                        textAlign: 'center',
                                    }}
                                >    
                                    {i++}                                     
                                </td>
                                <td 
                                    style={{
                                        borderLeft: '1px solid black', 
                                        borderRight: '1px solid black',
                                        padding: '1mm 2mm',
                                    }}
                                >
                                    {translate(key)}                        
                                </td>
                                <td 
                                    style={{
                                        borderLeft: '1px solid black', 
                                        borderRight: '1px solid black',
                                        padding: '1mm 2mm',
                                        textAlign: 'center',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    {rodzaj_rozliczenia(rodzaj, key)}       
                                </td>
                                <td 
                                    style={{
                                        borderLeft: '1px solid black', 
                                        borderRight: '1px solid black',
                                        padding: '1mm 2mm',
                                        textAlign: 'center',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    { isNaN(podstawa_) ? 0 : podstawa_}      
                                </td>
                                <td 
                                    style={{
                                        borderLeft: '1px solid black', 
                                        borderRight: '1px solid black',
                                        padding: '1mm 2mm',
                                        textAlign: 'center',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    {zl(cena)}                              
                                </td>
                                <td 
                                    style={{
                                        borderLeft: '1px solid black', 
                                        borderRight: '1px solid black',
                                        padding: '1mm 2mm',
                                        textAlign: 'right',
                                        whiteSpace: 'nowrap'
                                    }}
                                >    
                                    {zl(tablicaCzynszeAkt[key])}            
                                </td>
                            </tr>
                        );
                    }
                }
            }

            const indy = stawkiJednorazoweInd?.filter( s => s?.id_user == mieszkaniec?.id_user && s.grupa_numer == udzialGrupaNota?.grupa_numer && rrrr_mm_dd_to_rrrr_mm(s?.msc) == msc);

            if (indy && indy?.length > 0) {
                const temp = indy?.map( (ind, j) => (
                    <tr key={-1}>
                        <td 
                            style={{
                                borderLeft: '1px solid black', 
                                borderRight: '1px solid black',
                                padding: '1mm 2mm',
                                textAlign: 'center',
                            }}
                        >    
                            {i++}                                     
                        </td>
                        <td 
                            style={{
                                borderLeft: '1px solid black', 
                                borderRight: '1px solid black',
                                padding: '1mm 2mm',
                            }}
                        >
                            {ind.opis}                        
                        </td>
                        <td 
                            style={{
                                borderLeft: '1px solid black', 
                                borderRight: '1px solid black',
                                padding: '1mm 2mm',
                                textAlign: 'center',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {/* {rodzaj_rozliczenia(rodzaj, key)}        */}
                        </td>
                        <td 
                            style={{
                                borderLeft: '1px solid black', 
                                borderRight: '1px solid black',
                                padding: '1mm 2mm',
                                textAlign: 'center',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {/* { isNaN(podstawa_) ? 0 : podstawa_}       */}
                        </td>
                        <td 
                            style={{
                                borderLeft: '1px solid black', 
                                borderRight: '1px solid black',
                                padding: '1mm 2mm',
                                textAlign: 'center',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {/* {zl(cena)}                               */}
                        </td>
                        <td 
                            style={{
                                borderLeft: '1px solid black', 
                                borderRight: '1px solid black',
                                padding: '1mm 2mm',
                                textAlign: 'right',
                                whiteSpace: 'nowrap'
                            }}
                        >    
                            {zl(ind.kwota)}            
                        </td>
                    </tr>
                    )
                );
                elements.push(temp)
            }


            return elements;
        } else return ""
    };

    return (
        <tbody key={0}>
            { tabela(stawki) }
            <tr key={-2}>
                {puste}
            </tr>
            <tr key={-1}>
                <td
                    style={{
                        border: '1px solid black',
                        textAlign: 'right',
                        padding: '1mm 2mm',
                        fontWeight: '600'
                    }}
                    colSpan={5}
                >
                    Razem:
                </td>
                <td 
                    style={{
                        border: '1px solid black', 
                        padding: '1mm',
                        textAlign: 'right',
                        fontWeight: '600'
                    }}
                >
                    {zl(tablicaCzynszeAkt?.czynsz_na_msc)}
                </td>
            </tr>
        </tbody>
    )
}

export default NotaTBody;